import { TabsList } from './tabs-list';
import { TabsPanel } from './tabs-panel';
import { TabsRoot } from './tabs-root';
import { TabsTab } from './tabs-tab';
import { TabsTabIcon } from './tabs-tab-icon';

export const Tabs = {
  Root: TabsRoot,
  List: TabsList,
  Panel: TabsPanel,
  Tab: TabsTab,
  TabIcon: TabsTabIcon,
};
